import { render, staticRenderFns } from "./TarefaForm.vue?vue&type=template&id=032fcb49&"
import script from "./TarefaForm.vue?vue&type=script&lang=js&"
export * from "./TarefaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports